import { render } from "./FrmNewOrder.vue?vue&type=template&id=4fe7a222"
import script from "./FrmNewOrder.vue?vue&type=script&lang=js"
export * from "./FrmNewOrder.vue?vue&type=script&lang=js"

import "./FrmNewOrder.vue?vue&type=style&index=0&id=4fe7a222&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__